import { Action, createReducer, on } from '@ngrx/store';
import { AdminCentralActions } from './admin-central.actions';

export const STORE_FEATURE_KEY_ADMIN_CENTRAL = 'adminCentral';

export interface AdminCentralState {
    resources: Array<any>;
}

export const initializeAdminCentralState: AdminCentralState = {
    resources: []
};

const reducer = createReducer(
    initializeAdminCentralState,
    on(AdminCentralActions.getResourcesSuccess, (state, { resources }) =>
        ({ ...state,
           resources
        }))
);

export function AdminCentralReducer(state: AdminCentralState | undefined, action: Action): AdminCentralState {
    return reducer(state, action);
}
